import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const removeRoundFromBookingAtom = atom(
  null,
  (get, set, roundId: string) => {
    const booking = get(currentBookingAtom);
    if (!booking) return;
    const updatedBooking = {
      ...booking,
      rounds: booking.rounds.filter((round) => round.localId !== roundId),
    };
    set(currentBookingAtom, updatedBooking);
  }
);
